<div class="carousel-wrapper">
	<div
		class="carousel-inner"
		[class.transition-enabled]="transitionEnabled"
		[class.position-center]="slidePosition === 'center'"
		[class.position-left]="slidePosition === 'left'"
		(transitionend)="onSlideTransitionEnd($event)"
	>
		@for (item of visibleItems; track getName($index, item)) {
			<div class="carousel-item">
				<ng-container *ngTemplateOutlet="item.template()!"></ng-container>
			</div>
		}
	</div>
</div>
